module.exports = __webpack_public_path__ + "static/very-good-jeeves-73406827b4de850fb5eb785e31b79dff.jpg";